module.exports = __webpack_public_path__ + "img/010_columbus_thumb.f9059982.jpg";